import axios from 'axios';

export const adminApi = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

let refreshing = null;

adminApi.interceptors.response.use(
  (res) => res,
  async (error) => {
    const original = error.config;
    const isAuthCall = original?.url?.startsWith('/auth/');
    if (error.response?.status === 401 && !original._retry && !isAuthCall) {
      original._retry = true;
      refreshing = refreshing || adminApi.post('/auth/refresh').finally(() => { refreshing = null; });
      try {
        await refreshing;
        return adminApi(original);
      } catch {
        window.dispatchEvent(new Event('admin-logged-out'));
      }
    }
    return Promise.reject(error);
  }
);

export const apiError = (e) => {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || 'Something went wrong. Please try again.';
  if (typeof d === 'string') return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(' ');
  return d.msg || String(d);
};

export const cleanParams = (obj) => Object.fromEntries(Object.entries(obj).filter(([, v]) => v !== '' && v !== null && v !== undefined && v !== 'all'));
